module.exports = __webpack_public_path__ + "static/img/1_1.f7a12fb3.jpg";